<template>
  <div v-show="showStyle">
    <header class="t-header" :class="headerBg()">
      <mt-header :title="caseInfo.case_number" class="mtheader">
        <router-link to="/History.html" slot="left">
          <mt-button icon="back"></mt-button>
        </router-link>
      </mt-header>
      <div class="h-tips" :class="stateClass()">{{ caseInfo.state }}</div>
    </header>
    <div class="card">
      <div
        v-show="caseInfo.reject_info != null && caseInfo.reject_info.length > 0"
      >
        <my-reject :arr="caseInfo.reject_info"></my-reject>
      </div>
      <div class="info">
        <h5>申请人信息</h5>
        <mt-cell title="姓名" :value="caseInfo.applier_name"></mt-cell>
        <mt-cell title="手机号码" :value="caseInfo.applier_tel"></mt-cell>
        <mt-cell title="证件类型" :value="caseInfo.applier_cardtype"></mt-cell>
        <mt-cell title="证件号" :value="caseInfo.applier_cardNo"></mt-cell>
        <h5>翻译文件信息</h5>
        <mt-cell title="文件类型" :value="caseInfo.trans_type"></mt-cell>
        <mt-cell title="原件语种" :value="caseInfo.trans_lan"></mt-cell>
        <div class="big-ceil">
          <div class="subtitle">相关附件</div>
          <div class="img-content">
            <mt-spinner
              color="#26a2ff"
              type="fading-circle"
              v-if="!caseInfo.trans_filesList"
            ></mt-spinner>
            <div
              class="imglist"
              v-if="
                caseInfo.trans_filesList && caseInfo.trans_filesList.length > 0
              "
            >
              <div v-for="f in caseInfo.trans_filesList" :key="f.guid">
                <img
                  :src="f.url"
                  width="72"
                  height="72"
                  @click="previewImg(f.url)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="big-ceil">
          <div class="subtitle">翻译备注</div>
          <div id="text-area" v-text="caseInfo.trans_bz"></div>
        </div>
        <h5>邮寄地址</h5>
        <mt-cell title="姓名" :value="caseInfo.post_name"></mt-cell>
        <mt-cell title="手机号码" :value="caseInfo.post_tel"></mt-cell>
        <mt-cell title="详细地址" :value="caseInfo.post_address"></mt-cell>
        <h5>电子发票</h5>
        <mt-cell title="缴费金额" :value="caseInfo.money"></mt-cell>
        <mt-cell title="发票类型" :value="caseInfo.ticket_type"></mt-cell>
        <div
          v-if="caseInfo.ticket_header != null && caseInfo.ticket_header != ''"
        >
          <mt-cell
            title="抬头类型"
            :value="caseInfo.ticket_header.type"
          ></mt-cell>
          <mt-cell
            :title="caseInfo.ticket_header.type == '个人' ? '姓名' : '名称'"
            :value="caseInfo.ticket_header.name"
          ></mt-cell>
          <mt-cell
            :title="
              caseInfo.ticket_header.type == '个人' ? '手机号码' : '联系电话'
            "
            :value="caseInfo.ticket_header.tel"
          ></mt-cell>
          <mt-cell
            title="电邮地址"
            :value="caseInfo.ticket_header.email"
          ></mt-cell>
          <mt-cell
            v-show="caseInfo.ticket_header.type == '单位'"
            title="信用代码"
            :value="caseInfo.ticket_header.code"
          ></mt-cell>
        </div>
      </div>
    </div>
    <footer style="margin:30px 0;" v-show="caseInfo.state == '已驳回'">
      <mt-button
        style="width:100%;background-color:#1E70E0;color:white;"
        @click.native="toFix()"
        >去修改</mt-button
      >
    </footer>
    <footer style="margin:30px 0;" v-show="caseInfo.state == '已审批'">
      <mt-button
        :disabled="paying"
        style="width:100%;background-color:#09BB07;color:white;"
        @click.native="toPay()"
        >微信支付</mt-button
      >
    </footer>
    <footer
      style="margin:30px 0;"
      v-show="caseInfo.state != '已审批' && caseInfo.state != '已驳回'"
    >
      <mt-button
        style="width:100%;background-color:#1E70E0;color:white;"
        @click.native="toBack()"
        >返回</mt-button
      >
    </footer>
    <my-preview
      :src="prevsrc"
      v-if="showPrev"
      :value="showPrev"
      @bindClose="closePrev"
    ></my-preview>
  </div>
</template>

<script>
import { MessageBox } from "mint-ui";
import { Indicator } from "mint-ui";
import preview from "@/components/common/preview.vue";
import reject from "@/components/common/reject.vue";

export default {
  components: {
    "my-preview": preview,
    "my-reject": reject
  },
  data() {
    return {
      caseInfo: {
        ticket_header: null,
        reject_info: []
      },
      prevsrc: "",
      showPrev: "",
      showStyle: false,
      showRejHistory: false,
      caseguid: "",
      prepay_info: "",
      paying: false
    };
  },
  mounted() {
    Indicator.open({ spinnerType: "fading-circle" });
    this.caseguid = this.$CommonFun.getUrlKey("caseguid");
    this.getCaseInfo();
  },

  methods: {
    toBack() {
      this.$router.push("/History.html");
    },
    isCanPay() {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.weChatPay(),
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.weChatPay());
          document.attachEvent("onWeixinJSBridgeReady", this.weChatPay());
        }
      } else {
        this.weChatPay();
      }
    },
    //请求预付
    toPay() {
      var self = this;
      this.paying = true;
      this.$Api
        .prePay(this.caseguid)
        .then(res => {
          var infoArr = res.data.split("#");
          self.prepay_info = {
            appId: "wx62acb935303f0db5",
            timeStamp: infoArr[0],
            nonceStr: infoArr[1],
            package: "prepay_id=" + infoArr[2],
            signType: "MD5",
            paySign: infoArr[3],
            outTradeNo: infoArr[4]
          };
        })
        .then(() => {
          self.isCanPay();
        });
    },
    //调起微信支付
    weChatPay() {
      var self = this;
      var payinfo = this.prepay_info;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: payinfo.appId,
          timeStamp: payinfo.timeStamp,
          nonceStr: payinfo.nonceStr,
          package: payinfo.package,
          signType: payinfo.signType,
          paySign: payinfo.paySign
        },
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            //支付成功
            var params = {
              caseguid: self.caseguid,
              caseid: self.caseInfo.case_number,
              money: self.caseInfo.money,
              outTradeNo: self.prepay_info.outTradeNo
            };
            self.$router.push({ path: "/Paysuc.html", query: params });
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            //取消支付
            self.paying = false;
            // self.$router.go(-1);
          } else if (res.err_msg == "get_brand_wcpay_request:fail") {
            //支付失败
            // self.$router.push(-1);
          }
        }
      );
    },

    toFix() {
      this.$router.push("/Application.html?caseguid=" + this.caseguid);
    },
    stateClass() {
      switch (this.caseInfo.state) {
        default:
          return "s-blue";
          break;
        case "已驳回":
          return "s-red";
          break;
        case "已审批":
          return "s-green";
          break;
      }
    },
    headerBg() {
      switch (this.caseInfo.state) {
        default:
          return "b-blue";
          break;
        case "已驳回":
          return "b-red";
          break;
        case "已审批":
          return "b-green";
          break;
      }
    },

    //预览图片
    previewImg(src) {
      this.showPrev = true;
      this.prevsrc = src;
    },
    closePrev() {
      this.showPrev = false;
    },
    //获取案件信息
    getCaseInfo() {
      var self = this;
      var tht = null;
      this.$Api.getCaseInfo(this.caseguid).then(res => {
        var caseobj = res.data;
        if (caseobj["电子发票信息"] != null && caseobj["电子发票信息"] != "") {
          var htArr = caseobj["电子发票信息"].split("#");
          if (htArr[0] == "个人") {
            tht = {
              type: htArr[0],
              name: htArr[1],
              tel: htArr[2],
              email: htArr[3]
            };
          }
          if (htArr[0] == "单位") {
            tht = {
              type: htArr[0],
              name: htArr[1],
              tel: htArr[2],
              email: htArr[3],
              code: htArr[4]
            };
          }
        }
        this.caseInfo = {
          state: caseobj["当前状态"],
          caseguid: caseobj["案件GUID"],
          case_number: caseobj["案件号"],
          applier_name: caseobj["申请人姓名"],
          applier_tel: caseobj["申请人联系电话"],
          applier_cardtype: caseobj["申请人证件类型"],
          applier_cardNo: caseobj["申请人证件号"],
          trans_type: caseobj["翻译文件类型"],
          trans_lan: caseobj["翻译件语种"],
          trans_filesList: null,
          trans_bz: caseobj["翻译备注"],
          post_name: caseobj["收件人姓名"],
          post_tel: caseobj["收件人电话"],
          post_address: caseobj["收件地址"],
          ticket_type: "电子普通发票",
          ticket_header: tht,
          reject_info: JSON.parse(caseobj["驳回记录"]),
          money: caseobj["总价分"]
            ? "￥ " + (Number(caseobj["总价分"]) / 100).toFixed(2)
            : "待定"
        };
        var list = JSON.parse(caseobj["相关附件"]);
        var arr = [];
        for (var i = 0; i < list.length; i++) {
          arr.push(this.getImg(list[i]["附件GUID"]));
        }
        Indicator.close();
        Promise.all(arr).then(res => {
          this.caseInfo.trans_filesList = res;
        });
        this.showStyle = true;
      });
    },
    //获取图片
    getImg(imgguid) {
      return this.$Api.getAdditionInfo(imgguid).then(res => ({
        url: "data:image/jpeg;base64," + res.data.base64,
        guid: res.data["附件GUID"]
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
.info .mint-cell >>> .mint-cell-title {
  color: #666;
  width: 20%;
  text-align: right;
}
.info .mint-cell >>> .mint-cell-value {
  width: 75%;
  margin-left: 5%;
  color: black;
}
.reject-content >>> .mint-cell-value {
  color: #e14444;
}
</style>

<style scoped>
.s-green {
  color: #84d6ac;
}
.s-red {
  color: #ff0000;
}
.s-blue {
  color: #1e70e0;
}
.b-green {
  background-color: #84d6ac;
}
.b-red {
  background-color: #ff0000;
}
.b-blue {
  background-color: #1e70e0;
}

.big-ceil {
  padding-top: 15px;
  border-top: 1px solid #c8c8cd;
  margin-left: 10px;
}
#text-area {
  width: 90%;
  box-sizing: border-box;
  margin: 10px;
  border-color: #c8c8cd;
  line-height: 1.5;
  padding: 5px;
  color: black;
}
.subtitle {
  border-left: 4px solid #1e70e0;
  padding-left: 15px;
  margin: 8px 0 8px 0;
}
.img-content {
  padding: 10px 5px;
}
.img-content,
.imglist {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.imglist img {
  margin: 10px 3px;
}
.t-header {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 200px;
  color: white;
  z-index: 1;
  padding: 0 15px;
  padding-bottom: 20%;
  box-sizing: border-box;
}
.mtheader {
  background-color: transparent;
  color: white;
  font-size: large;
}
.h-tips {
  font-size: 18px;
  text-align: center;
  line-height: 25px;
  padding: 10px;
  font-size: large;
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 25px;
  border-radius: 0 0 0 10px;
  background-color: white;
  font-weight: bold;
  letter-spacing: 1px;
}
.h-icon {
  justify-self: self-end;
}
.card {
  position: relative;
  z-index: 2;
  background-color: white;
  border-radius: 10px;
  margin-top: 70px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  padding: 15px;
  box-sizing: border-box;
  text-align: left;
}
.card .price {
  position: absolute;
  top: 15px;
  right: 15px;
  color: #e61919;
  font-size: 15px;
  font-weight: bold;
}
.card p {
  color: #222222;
  font-size: 13px;
}
.card span {
  color: #3e3e3e;
  font-size: 12px;
}
.o-detail {
  display: flex;
  align-items: center;
  text-align: left;
}
.o-d-left {
  width: 30%;
  font-size: 13px;
  color: #222222;
}
.o-d-right {
  width: 65%;
  font-size: 12px;
  color: #3e3e3e;
}
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue